import { useDocTitle } from 'util/hooks'

import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import 'css/success.css'

export const Success = () => {
	const searchParams = useMemo(() => new URLSearchParams(window.location.search), [])
	const from = searchParams.get('from')

	// If user came from settings, they're logged in - go to dashboard
	// Otherwise, they need to log in with new password
	const redirectPath = from === 'settings' ? '/dashboard' : '/login'
	const buttonText = from === 'settings' ? 'Back to Dashboard' : 'Log in'

	useDocTitle('All for One - Success')

	return (
		<section className="success-container">
			<h1 className="success-header">Success<span className="highlight">!</span></h1>

			<p className="success-message">
				You have successfully reset your password for your account.
			</p>

			<div className="success-actions">
				<Link to={redirectPath} className="success-btn">{buttonText}</Link>
			</div>
		</section>
	)
}
